<script>
  import Help from "../components/help.svelte";
  </script>
<svelte:head>
  <title>Info | eAdmissions</title>
</svelte:head>
  <Help helpId={"Guidance"} showSearchOption={true} back="/help"/>